/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/workforce': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 0C4.478 0 0 4.477 0 10s4.478 10 10 10 10-4.477 10-10S15.522 0 10 0zm2.973 17.421c-.92.37-1.922.579-2.973.579a7.957 7.957 0 01-2.966-.576l.028-3.254c0-2.165 1.02-3.643 2.363-4.029A2.36 2.36 0 017.652 7.86a2.358 2.358 0 012.279-2.357c1.422 0 2.398 1.081 2.398 2.357 0 1.099-.756 2.019-1.807 2.28 1.387.387 2.451 1.864 2.451 4.029v3.252z"/>'
  }
})
